import moment from 'moment'
import { validate } from 'vee-validate'

const dot = require('dot-object')

const SysUtils = {
  debug (obj) {
    console.log(this.name + ':' + JSON.stringify(obj))
  },
  copyObjectValue (target, source) {
    $.extend(true, target, source)
    return target
  },
  cloneObject (source) {
    let target
    if (source instanceof Array) {
      target = []
      $.extend(true, target, source)
    } else if (source instanceof Object) {
      target = {}
      $.extend(true, target, source)
    } else {
      target = source
    }
    return target
  },
  convStringToRangeDate: (rangeStr) => {
    if (SysUtils.isEmpty(rangeStr)) {
      return null
    }
    const arr = rangeStr.match(/(\d{4}\/\d{2}\/\d{2})(\s-\s)(\d{4}\/\d{2}\/\d{2})$/)
    if (arr === null || arr.length !== 4) {
      return null
    }
    return { startDate: arr[1], endDate: arr[3] }
  },
  convRangeDateString: (rangeObj) => {
    if (!rangeObj) {
      return ''
    } else {
      return moment(rangeObj.startDate).format('YYYY/MM/DD') + ' - ' + moment(rangeObj.endDate).format('YYYY/MM/DD')
    }
  },
  getRandnum () {
    return Math.floor(Math.random() * 9999)
  },
  formatDate: (value, format) => {
    return moment(value, 'YYYY/MM/DD').format(format)
  },
  checkDateFormat (value, format) {
    return (moment(value, format).format(format) === value)
  },
  convSelectArrToMap: (selectArr) => {
    const map = {}
    selectArr.forEach(function (obj1) {
      if ('children' in obj1) {
        obj1.children.forEach(function (obj2) {
          map[obj2.id] = obj2.text
        })
      } else {
        map[obj1.id] = obj1.text
      }
    })
    return map
  },
  getDate (addDay) {
    return moment().add(addDay, 'days').format('YYYY/MM/DD')
  },
  convDbArrToSelectArr: function (dbArr, idCol, valCol, grpCol) {
    let labelFunc = function (obj) {
      return obj[valCol]
    }
    if ((typeof valCol) === 'function') {
      labelFunc = valCol
    }

    if (grpCol !== undefined) {
      const selMap = {}
      dbArr.forEach(function (obj) {
        if (!(obj[grpCol] in selMap)) {
          selMap[obj[grpCol]] = {
            text: obj[grpCol],
            children: []
          }
        }
        selMap[obj[grpCol]].children.push({ id: obj[idCol], text: labelFunc(obj), grp: obj[grpCol] })
      })
      return $.map(selMap, function (value, index) { return value })
    } else {
      const selArr = []
      dbArr.forEach(function (obj) {
        selArr.push({ id: obj[idCol], text: labelFunc(obj) })
      })
      return selArr
    }
  },
  createHideString: function (ch, length) {
    let label = ''
    for (let i = 0; i < length; i++) {
      label = label + ch
    }
    return label
  },
  existsKey (arr, key) {
    if (arr) {
      return (key in arr)
    } else {
      return false
    }
  },
  isEmpty: function (value) {
    if (value === undefined || value === null || value === '') {
      return (true)
    }
    if (value instanceof Array) {
      return (value.length === 0)
    }
    if (value instanceof Object) {
      return (Object.keys(value).length === 0)
    }
  },
  createTableConfig (config) {
    const listFields = []
    Object.keys(config.fields).forEach(function (key) {
      const val = config.fields[key]
      val.data = key
      if (val.listView) {
        listFields.push(val)
      }
    })
    config.listFields = listFields
    return config
  },
  objectEquals (a, b) {
    if (a === b) {
      return true
    }
    return JSON.stringify(a) === JSON.stringify(b)
  },
  hexToRgb (hex) {
    let r = 0; let g = 0; let b = 0
    if (hex.length === 4) {
      r = '0x' + hex[1] + hex[1]
      g = '0x' + hex[2] + hex[2]
      b = '0x' + hex[3] + hex[3]
    } else if (hex.length === 7) {
      r = '0x' + hex[1] + hex[2]
      g = '0x' + hex[3] + hex[4]
      b = '0x' + hex[5] + hex[6]
    }

    return [r, g, b]
  },
  hexToHsl (hex) {
    const rgb = this.hexToRgb(hex)

    const r = rgb[0] / 255
    const g = rgb[1] / 255
    const b = rgb[2] / 255
    const cmin = Math.min(r, g, b)
    const cmax = Math.max(r, g, b)
    const delta = cmax - cmin
    let h = 0
    let s = 0
    let l = 0

    if (delta === 0) { h = 0 } else if (cmax === r) { h = ((g - b) / delta) % 6 } else if (cmax === g) { h = (b - r) / delta + 2 } else { h = (r - g) / delta + 4 }

    h = Math.round(h * 60)

    if (h < 0) { h += 360 }

    l = (cmax + cmin) / 2
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1))
    s = +(s * 100).toFixed(1)
    l = +(l * 100).toFixed(1)

    return [h, s, l]
  },
  textContrast (backgroundHex) {
    const hsl = this.hexToHsl(backgroundHex)

    hsl[0] = (hsl[0] / 360 + 0.5) % 1 // Hue
    hsl[1] = (hsl[1] / 100 + 0.5) % 1 // Saturation
    hsl[2] = (hsl[2] / 100 + 0.5) % 1 // Luminocity

    return [(hsl[0] * 360), (hsl[1] * 100), (hsl[2] * 100)]
  },
  flattenObject (ob) {
    const dotOb = dot.dot(ob)
    const keyArr = Object.keys(dotOb)
    keyArr.forEach(key => {
      const newKey = key.split('.')[key.split('.').length - 1]
      dotOb[newKey] = dotOb[key]
      if (newKey !== key) { delete dotOb[key] }
    })
    return dotOb
  },
  getCookie (name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
    return null
  },
  currentLocale () {
    return this.getCookie('locale')
  },
  validateInput (field, rule, op) {
    const options = Object.assign({ bails: false }, op)
    return validate(field, rule, options).then((result) => {
      return result
    })
  },
  validate (row, validation, dotSyntax = false, full = false) {
    const currentLocale = this.currentLocale()
    const dotRow = dot.dot(row)
    const dotRules = dot.dot(validation.rules)
    let messages = validation.messages[currentLocale]
    const arr = []
    const arrKey = []

    messages = messages || []

    // eslint-disable-next-line
    for (let [key, value] of Object.entries(dotRules)) {
      if (this.existsKey(dotRow, key) || !value.includes('sometimes')) {
        const options = {
          name: key,
          values: dotRow,
          customMessages: dot.pick(key, messages)
        }
        arrKey.push(key)
        arr.push(this.validateInput(dotRow[key], value, options))
      }
    }
    return Promise.all(arr)
      .then(data => {
        const obj = {}
        let valid = true
        arrKey.forEach((key, index) => {
          if (!data[index].valid) { valid = false }
          if (dotSyntax) {
            full ? obj[key] = data[index] : obj[key] = data[index].errors
          } else {
            full ? dot.str(key, data[index], obj) : dot.str(key, data[index].errors, obj)
          }
        })
        return { valid: valid, results: obj }
      })
  }
}
export default SysUtils
